
import { Component, ElementRef } from '@angular/core';
import { PageBase } from 't4core';
import { RentalEventInfo } from 't4core';
import { CSEventlogDialog } from '../../dialogs/CSEventlogDialog/CSEventlogDialog';
@Component({
  styleUrls: ['./LateRentals.css'],
  selector: 'LateRentals',
  templateUrl: './LateRentals.component.html',
})
export class LateRentalsComponent extends PageBase {
    constructor(el: ElementRef) {
      super(el, "LateRentals");
  }

  public async showCSHistory(row: any) {
    var result = await this.Dialog.open(CSEventlogDialog, { data: { RentalId: row.RentalId } }).afterClosed().toPromise();
  }


}
